import type { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getFullTechnicianAvailability = async ({
  technicianId,
  startDate,
  serviceSelectionId,
  serviceType,
  daysAmount = 5,
}: JsonDataItem) => {
  const data = await baseQuery(
    `technicians/${technicianId}/full-availability?start_date=${startDate}&no_of_days=${daysAmount}&service_selection_id=${serviceSelectionId}&service_type=${serviceType}`,
  );
  return data;
};
